<template>
  <v-layout class="main-wrapper" column>
    <v-app-bar color="neutral" app flat>
      <v-btn class="btn-icon" icon @click="handleDrawer()">
        <v-icon>mdi-menu</v-icon>
      </v-btn>

      <div
        v-if="$vuetify.breakpoint.smAndUp"
        class="pl-2 text-h6 font-weight-regular neutral6--text"
      >
        {{ $route?.meta?.title }}
      </div>

      <v-spacer />

      <v-avatar size="2.125rem" color="neutral1">
        <v-icon color="neutral4" small>fas fa-user</v-icon>
      </v-avatar>
    </v-app-bar>

    <v-navigation-drawer
      v-model="drawer"
      class="side-drawer py-4 pl-4"
      color="transparent"
      width="300"
      elevation="0"
      floating
      app
    >
      <v-card class="card card-drawer pa-2 pb-4" color="neutral1" height="100%">
        <div class="d-flex flex-column fill-height">
          <div class="d-flex justify-center mt-3 mb-6">
            <v-img
              :src="require(`@/assets/logotype.png`)"
              height="2rem"
              max-width="12rem"
              contain
            />
          </div>

          <div class="custom-divider mb-6" />

          <v-list class="py-0" color="transparent" nav>
            <template v-for="(item, i) in _routes">
              <router-link
                v-slot="{ href, navigate, isActive }"
                :to="item.path"
                :key="i"
                custom
              >
                <v-list-item
                  class="mb-2 pl-3 rounded-xl py-1"
                  :href="href"
                  :class="{ neutral2: isActive }"
                  @click="navigate"
                >
                  <v-list-item-avatar
                    class="mr-4"
                    :color="isActive ? 'primary' : 'neutral2'"
                    rounded="xl"
                    size="2.5rem"
                  >
                    <v-icon :color="isActive ? 'white' : 'textPrimary'" small>
                      {{ item.icon }}
                    </v-icon>
                  </v-list-item-avatar>

                  <v-list-item-title class="textPrimary--text text-body-1">
                    {{ item.label }}
                  </v-list-item-title>
                </v-list-item>
              </router-link>
            </template>
          </v-list>

          <v-spacer />

          <v-list class="py-0 transparent" nav>
            <v-list-item class="pl-3 rounded-xl py-1" @click="signOut()">
              <v-list-item-avatar class="mr-4" rounded="xl" size="2.5rem">
                <v-icon color="textPrimary"> mdi-logout </v-icon>
              </v-list-item-avatar>

              <v-list-item-title class="textPrimary--text text-body-1">
                Sair
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </div>
      </v-card>
    </v-navigation-drawer>

    <router-view />
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Main",

  data() {
    return {
      drawer: true,
      mini: false,
    };
  },

  computed: {
    ...mapGetters({
      _user: "user",
    }),

    _routes() {
      return [
        {
          icon: "fas fa-home",
          label: "Dashboard",
          path: "/home",
        },
        {
          icon: "fas fa-hotel",
          label: "Empreendimentos",
          path: "/marketplace",
        },
        {
          icon: "fas fa-chart-bar",
          label: "Retornos",
          path: "/returns",
        },
        {
          icon: "fas fa-credit-card",
          label: "Saldos e Pagamentos",
          path: "/billing",
        },
        {
          icon: "fas fa-user-alt",
          label: "Perfil",
          path: "/profile",
        },
      ];
    },
  },

  methods: {
    handleDrawer() {
      this.drawer = !this.drawer;
    },

    signOut() {
      this.$root.$emit("sign-out");
    },
  },
};
</script>

<style lang="scss" src="./style.scss" scoped />
